import { CachedCRUDService } from '../../../types/cached-c-r-u-d.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { ServerResponse } from '../../../types/http.interfaces';
import { environment } from '../../../../../environments/environment';
import { ClosingCode } from '@sisem/sisem-incidents-types';

@Injectable({
  providedIn: 'root',
})
export class IncidentsClosingCodesUnfilteredService extends CachedCRUDService<ClosingCode, never, never> {
  constructor(
    private http: HttpClient,
  ) {
    super();
    this.options.cacheExpiration = -1; // should almost never change, set don't expire
  }

  protected override async _fetchNewData(): Promise<ClosingCode[]> {
    let params = new HttpParams();

    params = params.set('fetchChildren', true);

    const response = await lastValueFrom(
      this.http.get<ServerResponse<ClosingCode[]>>(
        environment.api + '/incidents-ms/api/v1/closingcodes',
        { params: params }
      )
    );
    return response.data;
  }
}
